import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=a70c5880&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a70c5880')) {
      api.createRecord('a70c5880', component.options)
    } else {
      api.reload('a70c5880', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=a70c5880&", function () {
      api.rerender('a70c5880', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2nsu5DKq6GjdN/JS/comp/ImgFallback.vue"
export default component.exports